import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCookieBite } from 'react-icons/fa';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const timer = setTimeout(() => {
        setVisible(true);
      }, 1500);
      
      return () => clearTimeout(timer);
    }
  }, []);
  
  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };
  
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 m-4 md:m-6 bg-white rounded-lg shadow-xl border-2 border-[#C9B194]"
        >
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6">
            <div className="flex items-center gap-3">
              <div className="text-[#102E50] hidden md:block">
                <FaCookieBite size={28} />
              </div>
              <div className="text-sm md:text-base text-center md:text-right text-gray-700">
                אתר זה משתמש בעוגיות (Cookies) לשיפור חווית המשתמש ולצרכי ניתוח סטטיסטי. 
                המשך הגלישה באתר מהווה את הסכמתך למדיניות הפרטיות שלנו.
              </div>
            </div>
            
            <div className="flex gap-3 items-center">
              <a 
                href="/privacy-policy" 
                className="text-[#102E50] hover:text-[#74512D] text-sm underline transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                מדיניות פרטיות
              </a>
              <motion.button 
                onClick={acceptCookies}
                className="px-6 py-2 bg-[#102E50] hover:bg-[#74512D] text-white rounded-full text-sm md:text-base font-medium transition-colors"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                הבנתי ומסכים/ה
              </motion.button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;